import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import "./b2cearlystage.css";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";
import swal from "sweetalert";
import Axios from "axios";

const FlipkartPOb2c = () => {
  const [barcode, setBarcode] = useState("");
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const [totalScanned, setTotalScanned] = useState(0);
  const [selectedMethod, setSelectedMethod] = useState("method1"); 
  const barcodeInputRef = useRef(null);



  const addBarcode = (newBarcode) => {
    if (/^[A-Za-z]/.test(newBarcode)) {
      if (!scannedBarcodes.includes(newBarcode)) {
        setScannedBarcodes((prevBarcodes) => [...prevBarcodes, newBarcode]);
        setTotalScanned((prevTotal) => prevTotal + 1);
        alertify.success("Barcode Scan Successfully", 3);
      } else {
        alertify.error("Barcode already scanned", 3);
      }
    } else {
      alertify.error("Scan Correct Barcode", 3);
    }
  };

  const handleManualBarcodeEntry = () => {
    if (barcode.trim() !== "") {
      const uppercaseBarcode = barcode.toUpperCase();
      addBarcode(uppercaseBarcode);
      setBarcode("");
      barcodeInputRef.current.focus();
    }
  };

  useEffect(() => {
    const handleBarcodeScan = (event) => {
      if (event.key === "Enter") {
        addBarcode(barcode);
        setBarcode("");
      }
    };

    const handleDocumentClick = (event) => {
      const clickedElement = event.target;
      if (
        clickedElement !== barcodeInputRef.current && 
        !clickedElement.closest(".B2C") && 
        !clickedElement.closest(".flipkart") && 
        !clickedElement.closest(".btn.btn-primary") 
      ) {
        barcodeInputRef.current.focus();
      }
    };

    window.addEventListener("keydown", handleBarcodeScan);
    document.addEventListener("click", handleDocumentClick); 

    return () => {
      window.removeEventListener("keydown", handleBarcodeScan);
      document.removeEventListener("click", handleDocumentClick); 
    };
  }, [barcode]);


  const handleSubmit = () => {
    if (selectedMethod === "method1") {
      const dataToSend = {
        barcodeData: scannedBarcodes,
        count: totalScanned,
      };

      swal({
        title: "Confirm",
        text: "Are you sure you want to submit the scanned data",
        icon: "warning",
        buttons: ["Cancel", "OK"],
      }).then((confirmed) => {
        if (confirmed) {
          Axios.post(`${INVENTORY_API_BASE_URL}/flipkartB2C`, dataToSend)
            .then((result) => {

              swal({
                title: "Outbound Completed",
                text: "",
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
            })
            .catch((error) => {
              alertify("Service error");
            });
        }
      });
    } else if (selectedMethod === "method2") {
      const dataToSend = {
        barcodeData: scannedBarcodes,
        count: totalScanned,
      };

      swal({
        title: "Confirm",
        text: "Are you sure you want to submit the scanned data",
        icon: "warning",
        buttons: ["Cancel", "OK"],
      }).then((confirmed) => {
        if (confirmed) {
          Axios.post(`${INVENTORY_API_BASE_URL}/AmazonB2C`, dataToSend)
            .then((result) => {

              swal({
                title: "Outbound Completed",
                text: "",
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
            })
            .catch((error) => {
              alertify("Service error");
            });
        }
      });
    } else if (selectedMethod === "method3") {
      const dataToSend = {
        barcodeData: scannedBarcodes,
        count: totalScanned,
      };

      swal({
        title: "Confirm",
        text: "Are you sure you want to submit the scanned data",
        icon: "warning",
        buttons: ["Cancel", "OK"],
      }).then((confirmed) => {
        if (confirmed) {
          Axios.post(`${INVENTORY_API_BASE_URL}/PinnacleB2C`, dataToSend)
            .then((result) => {

              swal({
                title: "Outbound Completed",
                text: "",
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
            })
            .catch((error) => {
              alertify("Service error");
            });
        }
      });
    } else if (selectedMethod === "method4") {
      const dataToSend = {
        barcodeData: scannedBarcodes,
        count: totalScanned,
      };

      swal({
        title: "Confirm",
        text: "Are you sure you want to submit the scanned data",
        icon: "warning",
        buttons: ["Cancel", "OK"],
      }).then((confirmed) => {
        if (confirmed) {
          Axios.post(`${INVENTORY_API_BASE_URL}/EmployeeB2C`, dataToSend)
            .then((result) => {

              swal({
                title: "Outbound Completed",
                text: "",
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
            })
            .catch((error) => {
              alertify("Service error");
            });
        }
      });
    }
  };

  return (
    <div style={{ marginLeft: "22rem", marginTop: "5rem" }}>
      <h2 style={{ marginBottom: "2rem" }}>B2C Early Stage</h2>

      <select
        value={selectedMethod}
        className="B2C"
        onChange={(e) => setSelectedMethod(e.target.value)}
      >
        <option value="method1">Flipkart B2C</option>
        <option value="method2">Amazon B2C</option>
        <option value="method3">Pinnacle B2C</option>
        <option value="method4">Employee B2C</option>
      </select>

      <p>Scan or Enter Barcode:</p>

      <input
        type="text"
        ref={barcodeInputRef}
        value={barcode}
        onChange={(e) => setBarcode(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />

      <button onClick={handleManualBarcodeEntry} className="flipkart">
        Add Manually
      </button>

      <div>
        <h3 className="scanned">Scanned Barcodes:</h3>
        <p>
          <b>Total Scanned: {totalScanned}</b>
        </p>
        <ul>
          {scannedBarcodes.map((barcode, index) => (
            <li key={index}>{barcode}</li>
          ))}
        </ul>
      </div>

      <button type="button" className="btn btn-primary" onClick={handleSubmit}>
        Scan Outbound
      </button>
    </div>
  );
};
export default FlipkartPOb2c;
